/**
 * @desc 界面管理
 * @author zl zhaolun@qfei.cn
 * @date 2024年01月04日09:55:54
 */
export default {
  界面管理: 'Interface Manage',
  菜单界面管理: 'Menu Manage',
  菜单项管理: 'Menu Item Manage',
  菜单界面名称: 'Menu Name',
  菜单项名称: 'Menu Item Name',
  基本设置: 'Basic Settings',
  菜单项类型: 'Menu Item Type',
  菜单图标: 'Menu Icon',
  请选择菜单图标: 'Please select the menu icon',
  请输入菜单项名称: 'Please enter the menu item name',
  '请输入API Name': 'Please enter the API name',
  请选择菜单项: 'Please select the menu item',
  可选: 'Options',
  分组: 'Group',
  创建分组: 'Create Group',
  自定义对象: 'Custom Object',
  自定义菜单: 'Custom Menu',
  分组名称: 'Group Name',
  分组不能拖动到其他分组下: 'Group cannot be dragged to other groups',
  '菜单不能含有子菜单，请创建分组': 'Menu cannot contain submenus, please create a group',
  请选择菜单: 'Please select the menu',
  其他菜单: 'Other menus',
  页面名称: 'Page Name',
  请输入页面名称: 'Please enter the page name'
};
